function isValidUrl(value) {
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
}

/** Same rules as the original's offerSchema (Zod, server-side). */
export function validateOffer({ title, landingUrl }) {
  if (title.trim().length < 2) return "Title must be at least 2 characters.";
  if (title.trim().length > 120) return "Title must be 120 characters or fewer.";
  if (!isValidUrl(landingUrl.trim())) return "Enter a valid landing page URL.";
  return null;
}